define('collections/extendedMarginManagementReportCollection',["jQuery", "T1", "T1Collection", "models/extendedMarginManagementReport"], function ($, T1, T1Collection, ExtendedMarginManagementReport) {
  T1.Models.ExtendedMarginManagementReportCollection = T1Collection.extend({
    model: ExtendedMarginManagementReport
  });
  return T1.Models.ExtendedMarginManagementReportCollection;
});
